import { useIntl } from 'react-intl';
import React, { useMemo } from 'react';
import { messages } from '../messages';
import { Text } from '@lifeomic/chroma-react/components/Text';
import { Tooltip } from '@lifeomic/chroma-react/components/Tooltip';
import { getExpressionValueAndUnit } from '../observationUtils';
import { getTestProps } from '../../../../../../util/testProps';

export const expressionVariantTestIds = {
  gene: 'expressionVariant-gene',
  expression: 'expressionVariant-expression',
};

export interface ExpressionVariantProps {
  gene: string;
  observation: fhir.Observation;
}

export const ExpressionVariant = (props: ExpressionVariantProps) => {
  const { formatMessage } = useIntl();
  const { gene, observation } = props;

  const expression = useMemo(() => {
    const valueAndUnit = getExpressionValueAndUnit(observation);
    if (!valueAndUnit) {
      return null;
    }
    return `${valueAndUnit.value} ${valueAndUnit.unit}`;
  }, [observation]);

  return (
    <>
      {gene && (
        <Tooltip title={formatMessage(messages.targetGene)}>
          <Text size="subbody" {...getTestProps(expressionVariantTestIds.gene)}>
            {gene}
          </Text>
        </Tooltip>
      )}
      {expression && (
        <Tooltip title={formatMessage(messages.expression)}>
          <Text
            size="subbody"
            {...getTestProps(expressionVariantTestIds.expression)}
          >
            {expression}
          </Text>
        </Tooltip>
      )}
    </>
  );
};
